import * as types from './actionTypes';

export const verifySlug = (payload) => {
  return {
    type: types.VERIFY_SLUG,
    payload,
  };
};
export const setVerifySlugStatus = (payload) => {
  return {
    type: types.SET_VERIFY_SLUG_STATUS,
    payload,
  };
};
export const paymentStep = (payload) => {
  return {
    type: types.PAYMENT_STEP,
    payload,
  };
};
export const paymentStatus = (payload) => {
  return {
    type: types.PAYMENT_STATUS,
    payload,
  };
};
export const setBusinessData = (payload) => {
  return {
    type: types.SET_BUSINESS_DATA,
    payload,
  };
};
export const createPayment = (payload) => {
  return {
    type: types.CREATE_PAYMENT,
    payload,
  };
};
export const createPaymentLoader = (payload) => {
  return {
    type: types.CREATE_PAYMENT_LOADER,
    payload,
  };
};
export const setUserPaymentDetails = (payload) => {
  return {
    type: types.SET_USER_PAYMENT_DETAILS,
    payload,
  };
};
export const paymentVerify = (payload) => {
  return {
    type: types.PAYMENT_VERIFY,
    payload,
  };
};
export const setPaymentVerifyStatus = (payload) => {
  return {
    type: types.SET_PAYMENT_VERIFY_STATUS,
    payload,
  };
};

export const completeStripeOnboarding = (payload) => {
  return {
    type: types.COMPLETE_STRIPE_ONBOARDING,
    payload,
  };
};

export const completeStripeOnboardingSuccess = (payload) => {
  return {
    type: types.COMPLETE_STRIPE_ONBOARDING_SUCCESS,
    payload,
  };
};

export const verifyStripeOnboardingStatus = (payload) => {
  return {
    type: types.VERIFY_STRIPE_ONBOARDING_STATUS,
    payload,
  };
};

export const setVerifyStripeOnboardingStatus = (payload) => {
  return {
    type: types.SET_VERIFY_STRIPE_ONBOARDING_STATUS,
    payload,
  };
};

export const getPaymentHistoryList = (payload) => {
  return {
    type: types.GET_PAYMENT_HISTORY_LIST,
    payload,
  };
};

export const getKPIData = (payload) => {
  return {
    type: types.GET_KPI_DATA,
    payload,
  };
};

export const setKPISData = (payload) => {
  return {
    type: types.SET_KPI_DATA,
    payload,
  };
};

export const getNextPagePaymentList = (payload) => {
  return {
    type: types.GET_NEXT_PAYMENT_LIST,
    payload,
  };
};

export const setPaymentHistoryList = (payload) => {
  return {
    type: types.SET_PAYMENT_HISTORY_LIST,
    payload,
  };
};
export const setPaymentSlug = (payload) => {
  return {
    type: types.SET_PAYMENT_SLUG,
    payload,
  };
};
